import { render } from "./AllowDeduc.vue?vue&type=template&id=6041696c"
import script from "./AllowDeduc.vue?vue&type=script&lang=js"
export * from "./AllowDeduc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__